<template>
  <div class="construction-cost-budget-table">
    <LableContent
      label="导入明细"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="580px"
    >
      <LeftRightBox
        height="100%"
        :leftWidthDefault="450"
        style="margin-bottom: 10px"
      >
        <template slot="left">
          <el-button
            type="primary"
            size="mini"
            @click="handleImport"
            style="margin-bottom: 10px"
            >导入建安预算</el-button
          >
          <SimpleTable
            ref="leftTable"
            table-code="budgetTableLeft"
            :menus="['查询', '批量修改', '批量删除']"
            :bottomFrozenRowCount="1"
            :columns="columns.left"
            :data="tableData.left"
            :loading="loading.left"
            @row-select="onRowSelectLeft"
            @modify-data-change="onModifyDataChangeLeft"
          />
        </template>
        <template slot="right">
          <TabBtn
            ref="tabBtnRef"
            :tabs="tabsRight"
            :active-tab="currentTab.right.value"
            height="unset"
            :style="`width: 100%;height: 100%'}`"
            @tab-click="tabClickRight"
          >
            <template slot="btn"> </template>
            <template
              v-if="currentTab.right.value !== 'constructionCostBudget_gkgk'"
            >
              <SimpleTable
                ref="rightTable"
                table-code="budgetTableRight"
                :menus="['查询']"
                :columns="columns.right"
                :data="tableData.right"
                :loading="loading.right"
              />
            </template>
            <template
              v-if="currentTab.right.value === 'constructionCostBudget_gkgk'"
            >
              <ProjectOverview
                ref="projectOverview"
                :businessId="currentSelect.left?.id"
              />
            </template>
          </TabBtn>
        </template>
      </LeftRightBox>
    </LableContent>
    <LableContent
      label="处理后明细"
      class="budget-table-bottom"
      hasCollapse
      showFullScreen
      height="450px"
    >
      <TabBtn
        ref="tabBtnRef"
        :tabs="tabsBottom"
        :active-tab="currentTab.bottom.value"
        height="100%"
        @tab-click="tabClickBottom"
      >
        <template slot="btn">
          <el-button
            type="primary"
            size="mini"
            v-if="
              currentTab.bottom.value !== 'constructionCostBudgetBottom_fyhz'
            "
            @click="handleImportToEdit"
            >导入转为编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="
              currentTab.bottom.value !== 'constructionCostBudgetBottom_fyhz' &&
              currentTab.bottom.value !== 'constructionCostBudgetBottom_jgcl'
            "
            @click="handleMatchHistoryDataSearch"
            >选择历史数据</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="
              currentTab.bottom.value !== 'constructionCostBudgetBottom_fyhz' &&
              currentTab.bottom.value !== 'constructionCostBudgetBottom_jgcl'
            "
            @click="handleMatchHistoryData"
            >无定额计价</el-button
          >
          <el-button
            type="primary"
            size="mini"
            v-if="
              currentTab.bottom.value === 'constructionCostBudgetBottom_fyhz'
            "
            @click="handleFeeCalculation"
            >取费计算</el-button
          >
        </template>
        <template>
          <LeftRightBox
            height="100%"
            :leftWidthDefault="450"
            style="margin-bottom: 10px"
          >
            <template
              slot="left"
              v-if="
                currentTab.bottom?.value === 'constructionCostBudgetBottom_fbfx'
              "
            >
              <SimpleTable
                ref="bottomLeftTable"
                table-code="bottomLeftTable"
                :menus="['查询', '批量修改', '批量删除']"
                :columns="columns.bottomLeft"
                :data="tableData.bottomLeft"
                :loading="loading.bottomLeft"
                @row-select="onRowSelectBottomLeft"
              />
            </template>
            <template slot="right">
              <SimpleTable
                ref="bottomTable"
                table-code="budgetTableBottom"
                :menus="[
                  '查询',
                  '批量修改',
                  '批量删除',
                  currentTab.bottom.value ===
                  'constructionCostBudgetBottom_fyhz'
                    ? '插入'
                    : null,

                  [
                    'constructionCostBudgetBottom_fbfx',
                    'constructionCostBudgetBottom_csxm'
                  ].includes(currentTab.bottom.value)
                    ? '插入清单子目'
                    : null
                ]"
                :bottomFrozenRowCount="
                  [
                    'constructionCostBudgetBottom_jgcl',
                    'constructionCostBudgetBottom_fbfx',
                    'constructionCostBudgetBottom_rcjhz'
                  ].includes(currentTab.bottom.value)
                    ? 1
                    : 0
                "
                :menusMergeAfter="menusMergeAfterBottom"
                :columns="columns.bottom"
                :data="tableData.bottom"
                :loading="loading.bottom"
                @modify-data-change="onModifyDataChangeBottom"
              />
            </template>
          </LeftRightBox>
        </template>
      </TabBtn>
    </LableContent>

    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
    <QingDanZiMu ref="qingDanZiMu" />

    <HistoryProjectDialog
      ref="historyProjectDialog"
      @confirm="handleInsertHistoryConfirm"
    />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin'
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import { sortRecords, getOptions, addCbFn, handleImport } from '@/utils/index'
import { columnsLeft, tabsRight, tabsBottom } from './config'
import SelectBaseAmountDialog from './SelectBaseAmountDialog.vue'
import QingDanZiMu from './Qingdanzimu.vue'
import HistoryProjectDialog from '../../DesignBudgetSoftware/InitialSchemeEstimate/HistoryProjectDialog.vue'
import LableContent from '@/components/LableContent/index.vue'
import ProjectOverview from '../../BigDataSoftware/HistoryData/ProjectOverview.vue'

export default {
  name: 'ConstructionCostBudgetTable',
  mixins: [tableMixin],
  components: {
    SimpleTable,
    LeftRightBox,
    TabBtn,
    SelectBaseAmountDialog,
    QingDanZiMu,
    HistoryProjectDialog,
    LableContent,
    ProjectOverview
  },
  inject: ['detailsVm'],
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabsRight,
      tabsBottom,
      tableData: {
        left: [],
        right: [],
        bottomLeft: [],
        bottom: []
      },
      apiUrl: {
        left: '/project-unit-budget/import-record',
        right: '',
        bottomLeft: '/project-unit-budget/new-bq-item/indicator-category-tree',
        bottom: ''
      },
      columns: {
        left: columnsLeft,
        right: [],
        bottomLeft: [{ field: 'name', title: '指标分类', tree: true }],
        bottom: []
      },
      loading: {
        left: false,
        right: false,
        bottomLeft: false,
        bottom: false
      },

      currentTab: {
        right: null,
        bottom: null
      },
      currentSelect: {
        left: null,
        right: null,
        bottomLeft: null,
        bottom: null
      }
    }
  },
  watch: {
    basicInfo() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    menusMergeAfterBottom(contextMenuMap) {
      const bol = [
        'constructionCostBudgetBottom_fbfx',
        'constructionCostBudgetBottom_csxm'
      ].includes(this.currentTab.bottom?.value)
      contextMenuMap['插入清单子目'] = bol ? () => this.handleInsertDE() : null

      if (
        this.currentTab.bottom?.value === 'constructionCostBudgetBottom_fyhz'
      ) {
        contextMenuMap['批量修改'] = () => this.handleEditBillBaseAmount()
      }
    },
    reset(obj) {
      const { left = true, right = true, bottom = true } = obj || {}
      if (left) this.tableData.left = []
      if (right) this.tableData.right = []
      if (bottom) this.tableData.bottom = []

      if (left) this.loading.left = false
      if (right) this.loading.right = false
      if (bottom) this.loading.bottom = false

      if (right) this.currentTab.right = null
      if (bottom) this.currentTab.bottom = null
    },

    init() {
      this.reset()
      this.tabClickRight(this.tabsRight[0])
      this.tabClickBottom(this.tabsBottom[0])

      if (!this.basicInfo?.id) return
      this.getTableData({
        type: 'left',
        url: this.apiUrl.left,
        isLocal: true,
        params: {
          budgetId: this.basicInfo.id
        }
      })
    },

    getBottomLeftParams() {
      return {
        budgetId: this.basicInfo.id,
        importRecordId: this.currentSelect.left?.id
      }
    },

    getBottomParams() {
      return {
        budgetId: this.basicInfo.id,
        importRecordId: this.currentSelect.left?.id,
        indicatorId:
          this.currentTab.bottom?.value === 'constructionCostBudgetBottom_fbfx'
            ? this.currentSelect.bottomLeft?.id
            : undefined,
        supplyType:
          this.currentTab.bottom?.value === 'constructionCostBudgetBottom_jgcl'
            ? '甲供材料'
            : undefined
      }
    },

    tabClickRight(tab) {
      this.currentTab.right = this.tabsRight.find(v => v.value === tab.value)
      this.columns.right = this.currentTab.right.columns
      this.apiUrl.right = this.currentTab.right.url

      if (!this.currentSelect.left?.id || !this.basicInfo?.id) return

      if (this.apiUrl.right) {
        this.getTableData({
          type: 'right',
          url: this.apiUrl.right,
          params: {
            importRecordId: this.currentSelect.left?.id
          }
        })
      }
    },
    tabClickBottom(tab) {
      this.currentTab.bottom = this.tabsBottom.find(v => v.value === tab.value)
      this.columns.bottom = this.currentTab.bottom.columns
      this.apiUrl.bottom = this.currentTab.bottom.url

      if (!this.currentSelect.left?.id || !this.basicInfo?.id) return
      this.getDeelData()
    },

    onRowSelectBottomLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.currentSelect.bottomLeft = obj

      this.getTableData({
        type: 'bottom',
        url: this.apiUrl.bottom,
        params: this.getBottomParams()
      })
    },

    // 页面方法
    async getTableData({ type, url, params, isLocal = false }) {
      this.loading[type] = true
      if (!url.includes('list')) {
        url = url + '/list'
      }
      const res = await this.$service.get(url, params)
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      if (isLocal && res.data?.length) this.$refs[type + 'Table'].initialized()
    },

    async onModifyDataChangeLeft(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        this.apiUrl.left + '/batch',
        getModifyData,
        cleanModifyData
      )

      if (
        this.currentTab.bottom?.value === 'constructionCostBudgetBottom_fbfx'
      ) {
        this.$refs.projectOverview.init()
      }
    },
    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        this.apiUrl.bottom + '/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            budgetId: this.basicInfo.id,
            importRecordId: this.currentSelect.left?.id
          }))
      )

      if (
        this.currentTab.bottom.value === 'constructionCostBudgetBottom_fbfx'
      ) {
        this.getTableData({
          type: 'bottomLeft',
          url: this.apiUrl.bottomLeft,
          params: this.getBottomLeftParams(),
          isLocal: false
        })

        this.getTableData({
          type: 'bottom',
          url: this.apiUrl.bottom,
          params: this.getBottomParams(),
          isLocal: false
        })
      }
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.currentSelect.left = obj
      if (!obj?.id) return
      this.tableData.right = []
      this.tableData.bottom = []

      if (!this.apiUrl.right) return

      this.getTableData({
        type: 'right',
        url: this.apiUrl.right,
        params: {
          importRecordId: obj?.id
        }
      })

      this.getDeelData()
    },

    getDeelData() {
      if (
        this.currentTab.bottom.value === 'constructionCostBudgetBottom_fbfx'
      ) {
        this.getTableData({
          type: 'bottomLeft',
          url: this.apiUrl.bottomLeft,
          params: this.getBottomLeftParams(),
          isLocal: true
        })
      } else {
        this.getTableData({
          type: 'bottom',
          url: this.apiUrl.bottom,
          params: this.getBottomParams()
        })
      }
    },

    handleImport() {
      handleImport({
        vm: this,
        multiple: false,
        uploadFn: this.uploadBudget
      })
    },
    async uploadBudget(files) {
      const formData = new FormData()
      formData.append('file', files)
      formData.append('id', this.basicInfo?.id)
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        'project-unit-budget/import',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.$message.success('导入成功')
        this.getTableData({
          type: 'left',
          url: this.apiUrl.left,
          isLocal: true,
          params: {
            budgetId: this.basicInfo.id
          }
        })
      }
    },

    // 取费基数编辑
    handleEditBillBaseAmount() {
      const selectedCellInfos = this.$refs.bottomTable.getSelectData()
      if (selectedCellInfos.length !== 1)
        return this.$message.warning('只能修改一条数据！')
      this.$refs.SelectBaseAmountDialog.show({
        id: this.basicInfo.id,
        selectedCellInfos: selectedCellInfos,
        tableVm: this.$refs.bottomTable
      })
    },

    // 取费基数编辑确认
    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs.bottomTable.modifyData.set(obj, obj)
      })
    },

    async handleFeeCalculation() {
      const res = await this.$service.post(
        '/project-unit-budget/calculateAmount/' + this.currentSelect.left?.id,
        { id: this.currentSelect.left?.id }
      )
      if (res.code === 200) {
        this.$message.success('取费计算成功')
        this.getDeelData()
      }
    },

    handleInsertDE() {
      this.$refs.qingDanZiMu.show({
        title: '插入清单子目',
        vm: this.$refs.bottomTable,
        budgtId: this.basicInfo.id,
        importRecordId: this.currentSelect.left?.id
      })
    },

    async handleMatchHistoryData() {
      this.$selectModal({
        title: '无定额计价',
        showConfirm: false,
        columns: [{ field: 'name', title: '历史数据' }],
        options: await this.getHistoryDataOptions(),
        allowMultiSelect: true
        // confirm: (selectedCellInfos, res) => {
        //   const arr = selectedCellInfos.map(e => e[0].originData)
        //   this.sendHistoryData(arr.map(e => e.id))
        // },
      })
    },

    async handleMatchHistoryDataSearch() {
      if (!this.currentSelect.left?.id) {
        this.$message.warning('请先选中一条预算记录数据')
        throw new Error('请先选中一条预算记录数据')
      }
      this.$refs.historyProjectDialog.show({
        title: '选择历史数据',
        mainId: this.basicInfo.id
      })
    },

    handleInsertHistoryConfirm(arr) {
      this.sendHistoryData(arr.map(e => e.id))
    },

    async getHistoryDataOptions() {
      if (!this.currentSelect.left?.id) {
        this.$message.warning('请先选中一条预算记录数据')
        throw new Error('请先选中一条预算记录数据')
      }
      const res = await this.$service.get(
        '/project-unit-budget/matched-history/list',
        { importRecordId: this.currentSelect.left?.id }
      )
      return (
        res?.data.map(e => ({
          name: e.historyDataName,
          id: e.historyDataId
        })) || []
      )
    },

    async sendHistoryData(historyDataIdList) {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/matchHisData',
        {
          importRecordId: this.currentSelect.left?.id,
          historyDataIdList
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.$message.success('选择成功')
        this.getDeelData()
      }
    },

    async handleImportToEdit() {
      this.detailsVm.loadingContainer = true
      const res = await this.$service.post(
        '/project-unit-budget/importToEdit/' + this.basicInfo.id,
        {
          id: this.basicInfo.id
        }
      )
      this.detailsVm.loadingContainer = false
      if (res.code === 200) {
        this.getDeelData()
      }
    }
  }
}
</script>

<style scoped lang="less">
.construction-cost-budget-table {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  .budget-table-bottom {
    height: calc(50% - 50px);
    ::v-deep > .content {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
